<template>
  <div class="shareBounced">
    <div class="shareBounced_con">
      <div
        class="shareBounced_con_item"
        v-for="item in sharelist"
        :key="item.id"
        @click="toShare(item)"
      >
        <div
          v-if="item.id !== 4"
          class="shareBounced_con_item_icon"
          :class="item.icon"
        ></div>
        <div v-if="item.id !== 4" class="shareBounced_con_item_text">
          {{ item.name }}
        </div>
        <div
          v-if="item.id == 4"
          v-clipboard:copy="copyLink"
          v-clipboard:success="onCopy"
          v-clipboard:error="onError"
          class="shareBounced_con_item_icon"
          :class="item.icon"
        ></div>
        <div
          v-if="item.id == 4"
          v-clipboard:copy="copyLink"
          v-clipboard:success="onCopy"
          v-clipboard:error="onError"
          class="shareBounced_con_item_text"
        >
          {{ item.name }}
        </div>
      </div>
    </div>
    <div class="van-action-sheet__gap"></div>
    <div class="shareBounced_bottom" @click="closeClick">取消</div>
  </div>
</template>
<script>
import { Toast } from 'vant';
import get from '@/api/get';
export default {
  name: 'shareBounced',
  props: ['shareData'],
  data() {
    return {
      sharelist: window.user.weixcode
        ? [
            {
              id: 4,
              name1: 'copy',
              name: '复制链接',
              icon: 'shareBounced_link'
            }
          ]
        : window.user.appkey == 1504685273578 && this.$store.state.isInGame
        ? [
            { id: 5, name1: 'world', name: '世界', icon: 'shareBounced_world' },
            { id: 6, name1: 'guild', name: '猎团', icon: 'shareBounced_union' },
            {},
            {},
            {},
            {
              id: 0,
              name1: 'wx',
              name: '微信好友',
              icon: 'shareBounced_weixin'
            },
            {
              id: 1,
              name1: 'wxmoment',
              name: '微信朋友圈',
              icon: 'shareBounced_circleFriends'
            },
            { id: 2, name1: 'wb', name: '微博', icon: 'shareBounced_weibo' },
            { id: 3, name1: 'qq', name: 'QQ', icon: 'shareBounced_QQ' },
            {
              id: 4,
              name1: 'copy',
              name: '复制链接',
              icon: 'shareBounced_link'
            }
          ]
        : [
            {
              id: 4,
              name1: 'copy',
              name: '复制链接',
              icon: 'shareBounced_link'
            }
          ],
      closeFlag: 0,
      copyLink: '',
      shareWay: 1
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      let Base64 = require('js-base64').Base64;
      let isQa = /^(test|qa)-/.test(location.hostname);
      let sysname = this.$store.state.system;
      switch (this.$store.state.gameType) {
        case 1:
          this.copyLink =
            'http://' +
            (isQa ? 'qa-' : '') +
            'lzgwy-community.zlongame.com/index.html?#/postShare?id=' +
            this.shareData.id;
          break;
        case 2:
          this.copyLink =
            'https://' +
            (isQa ? 'qa-' : '') +
            'ma-community.tentree-games.com/index.html?#/postShare?id=' +
            this.shareData.id;
          break;
        case 3:
          this.copyLink =
            'http://' +
            (isQa ? 'qa-' : '') +
            'epic7-community.zlongame.com/index.html?#/postShare?id=' +
            this.shareData.id;
          break;
        case 4:
          this.copyLink =
            'http://' +
            (isQa ? 'qa-' : '') +
            'lhlr-community.zlongame.com/index.html?#/postShare?id=' +
            this.shareData.id;
          break;
        case 5:
          this.copyLink =
            'http://' +
            (isQa ? 'qa-' : '') +
            'rox-community.zlongame.com/index.html?#/postShare?id=' +
            this.shareData.id;
          break;
        default:
          break;
      }
      // if (
      //   this.$store.state.gameType == 2
      //   // window.user.appkey == 1705460260139
      // ) {

      //   // '&appkey=1705460260139';
      // }
      if (sysname == 'u3dPc') {
        if (this.$store.state.gameType == 2) {
          this.sharelist = [
            {
              id: 4,
              name1: 'copy',
              name: '复制链接',
              icon: 'shareBounced_link'
            }
          ];
        } else {
          this.sharelist = [
            { id: 5, name1: 'world', name: '世界', icon: 'shareBounced_world' },
            { id: 6, name1: 'guild', name: '猎团', icon: 'shareBounced_union' },
            {
              id: 4,
              name1: 'copy',
              name: '复制链接',
              icon: 'shareBounced_link'
            }
          ];
        }
      }
    },
    closeClick() {
      this.$emit('shareShowFlag', false);
    },
    toShare(item) {
      let Base64 = require('js-base64').Base64;
      let isQa = /^(test|qa)-/.test(location.hostname);
      let axiosbaseURL = '//sns' + (isQa ? 'test' : '') + '.zlongame.com';
      let shareParams = {
        shareType: 'topic',
        sharePlatform: '',
        url:
          'http://' +
          (isQa ? 'qa-' : '') +
          'www.zlongame.com/community/index.html?#/postShare?id=' +
          this.shareData.id,
        topicId: this.shareData.id,
        title: this.shareData.title || '龙之国物语 游戏社区',
        content: this.shareData.description,
        imageUrl: 'https://lzgwy.zlongame.com/m/img/logo.png'
      };
      shareParams.title = shareParams.title.slice(0, 25);
      shareParams.title = shareParams.title.replace(/[\r\n<br><br\/>]/g, '');
      shareParams.sharePlatform = item.name1;
      let sysname = this.$store.state.system;
      this.shareWay = item.id - 0 + 1;
      let shareStatisticsInfo = {
        way: this.shareWay
      };
      switch (item.id) {
        case 0:
        case 1:
        case 2:
        case 3:
          this.closeFlag = 0;
          break;
        case 4:
          this.closeFlag = 0;
          get
            .shareStatistics(shareParams.topicId, shareStatisticsInfo)
            .then((res) => {
              console.log(res);
            });
          return;
          break;
        case 5:
        case 6:
          shareParams.title =
            this.shareData.title || this.shareData.description;
          shareParams.title = shareParams.title.slice(0, 25);
          shareParams.title = shareParams.title.replace(
            /[\r\n<br><br\/>]/g,
            ''
          );
          this.closeFlag = 1;
          break;
        default:
          return;
          break;
      }
      get
        .shareStatistics(shareParams.topicId, shareStatisticsInfo)
        .then((res) => {
          console.log(res);
        });
      if (sysname == 'iphone') {
        shareParams.url = Base64.encode(shareParams.url);
        window.location.href =
          'iosn://pd_bbs_actv_share?closeFlag=' +
          this.closeFlag +
          '&shareType=' +
          shareParams.shareType +
          '&sharePlatform=' +
          shareParams.sharePlatform +
          '&url=' +
          shareParams.url +
          '&title=' +
          shareParams.title +
          '&topicId=' +
          shareParams.topicId +
          '&content=' +
          shareParams.content +
          '&imageUrl=' +
          shareParams.imageUrl;
      } else if (sysname == 'android') {
        window.pd.bbsShare(this.closeFlag, JSON.stringify(shareParams));
      } else if (sysname == 'u3dPc') {
        window['bbsShare'](this.closeFlag, shareParams);
      } else {
        alert('当前平台不支持分享');
      }
    },
    // 复制成功
    onCopy(e) {
      Toast('复制成功');
    },
    // 复制失败
    onError(e) {
      Toast('复制失败');
    }
  }
};
</script>
<style scoped></style>